import { render, staticRenderFns } from "./questionBank_info_subject.vue?vue&type=template&id=e6d2ee3e&scoped=true"
import script from "./questionBank_info_subject.vue?vue&type=script&lang=js"
export * from "./questionBank_info_subject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d2ee3e",
  null
  
)

export default component.exports